'use client';

import { createContext, useContext, ReactNode } from 'react';

// Current article path (e.g. "/kundservice/kontakta-oss"), stripped of the /artikel prefix.
const ArticlePathContext = createContext<string | undefined>(undefined);

interface ArticlePathProviderProps {
  path: string;
  children: ReactNode;
}

// Provides the article path to the subtree; wrap ArticlePageClient content with this.
export function ArticlePathProvider({ path, children }: ArticlePathProviderProps) {
  return <ArticlePathContext.Provider value={path}>{children}</ArticlePathContext.Provider>;
}

// Returns the article path, or undefined if outside one.
export function useArticlePath(): string | undefined {
  return useContext(ArticlePathContext);
}
